// for add employee
export const RESET_CALCULATE_EMPLOYEE_SALARY =
    "reset_calculate_employee_salary";
export const CALCULATE_EMPLOYEE_SALARY = "calculate_employee_salary";
export const CALCULATE_EMPLOYEE_SALARY_SUCCESS =
    "calculate_employee_salary_success";
export const CALCULATE_EMPLOYEE_SALARY_FAILURE =
    "calculate_employee_salary_failure";
